<template>
  <div class="approval-change-status">
    <b-modal
      ref="approval-change-status"
      hide-footer
      title="Đổi trạng thái phiếu duyệt chi"
      no-close-on-backdrop
      size="lg"
    >
      <b-table
        class="table-common"
        hover
        bordered
        :items="approvalItems"
        :fields="fields"
      >
        <template #cell(statusValidate)="data">
          <div v-if="!data.item.onLoading" class="d-table-row">
            <div class="d-table-cell align-middle" style="width: 10%">
              <i
                v-b-tooltip.hover
                :title="htmlGetStatusValidate(data.item, 'title')"
                :class="htmlGetStatusValidate(data.item, 'class')"
              ></i>
            </div>
            <div class="d-table-cell align-middle pb-1 pl-2" style="width: 90%">
              {{ data.item.statusValidateName }}
            </div>
          </div>
          <div v-else>
            <b-spinner
              small
              label="Small Spinner"
              variant="primary"
              class="mr-1"
            ></b-spinner>
            <span class="text-primary">Đang xử lí...</span>
          </div>
        </template>
        <template #cell(status)="data">
          <b-form-group class="mb-0 d-flex align-items-center">
            <div class="d-table-row">
              <div class="d-table-cell align-middle" style="width: 40%">
                <label class="font-weight-bold pt-1">
                  {{ data.item.statusName }}
                </label>
              </div>
              <div class="d-table-cell align-middle" style="width: 10%">
                <i
                  class="fa fa-arrow-right text-primary"
                  aria-hidden="true"
                ></i>
              </div>
              <div class="d-table-cell align-middle pb-1" style="width: 55%">
                <treeselect
                  :options="optionStatus"
                  :multiple="false"
                  placeholder="Chọn trạng thái"
                  noResultsText="Không có kết quả"
                  :match-keys="['label', 'custom']"
                  v-model="data.item.toStatus"
                  openDirection="bottom"
                  :clearable="false"
                  @select="onSelectStatus"
                >
                  <label
                    slot="option-label"
                    slot-scope="{ node, labelClassName }"
                    :class="labelClassName"
                  >
                    <span :title="node.label"> {{ node.label }}</span>
                  </label>
                </treeselect>
                <div v-if="isShowOption(data.item, 'accountant')">
                  <Autosuggest
                    class="border-radius-none mt-2"
                    :model="handleSearchCash"
                    :suggestions="filteredAccountantOptions"
                    placeholder="tài khoản thanh toán"
                    :limit="200"
                    @select="onSelectedAccountant"
                    @change="onInputChangeAccountant"
                    :disabled="!filteredAccountantOptions.length"
                    suggestionName="suggestionName"
                  />
                </div>
                <span
                  class="tree-select-custom"
                  v-if="isShowOption(data.item, 'fail-reason')"
                >
                  <treeselect
                    :options="optionFailReasons"
                    :multiple="false"
                    placeholder="Chọn lý do không thành công"
                    noResultsText="Không có kết quả"
                    :match-keys="['label', 'custom']"
                    v-model="data.item.failReason"
                    openDirection="bottom"
                    :clearable="false"
                  >
                    <label
                      slot="option-label"
                      slot-scope="{ node, labelClassName }"
                      :class="labelClassName"
                    >
                      <span :title="node.label"> {{ node.label }}</span>
                    </label>
                  </treeselect>
                </span>
              </div>
            </div>
          </b-form-group>
        </template>
      </b-table>
      <b-button
        style="fontweight: 600; width: 70px"
        variant="primary"
        size="sm"
        @click="onSubmit"
        >Lưu</b-button
      >
      <b-button
        style="margin-left: 10px; font-weight: 600; width: 70px"
        variant="secondary"
        size="sm"
        @click="hideModal"
        >Hủy</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {
  APPROVAL_STEP_STATUS,
  APPROVAL_PAYMENT_TYPE,
  JOB_TITLE_ACCOUNTANT,
  JOB_TITLE_SHOW_BY_OWNER,
} from '@/utils/enum';
import {
  APPROVAL_STATUS,
  FAIL_REASON,
  APPROVAL_STATUS_ACCOUNTANT_ONLY,
} from '@/utils/constants';
import { makeToastFaile, makeToastSuccess, cloneDeep } from '@/utils/common';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { cmdUrl } from '@/utils/apiUrl';
import { map } from 'lodash';
import { checkPermission, getData } from '@/utils/saveDataToLocal';
import { v4 as uuidv4 } from 'uuid';
import { featureFlagMixin } from '@/view/mixins';
const thStyleCommon = {
  textAlign: 'center',
  fontWeight: 600,
  color: '#181c32',
  width: '5%',
};
const STATUS_VALIDATE = {
  INVALID: 0,
  VALID: 1,
  REQUIRED: 2,
};

export default {
  mixins: [featureFlagMixin],
  data() {
    return {
      fields: [
        {
          key: 'code',
          label: 'Mã',
          thStyle: {
            ...thStyleCommon,
            width: '20%',
          },
          formatter: (value) => {
            return `#${value}`;
          },
          tdClass: 'align-middle',
        },
        {
          key: 'status',
          label: 'Đổi trạng thái',
          thStyle: {
            ...thStyleCommon,
            width: '50%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'statusValidate',
          label: 'Kiểm tra',
          thStyle: {
            ...thStyleCommon,
            width: '30%',
          },
          tdClass: 'align-middle',
        },
      ],
      approvalItems: [],
      optionStatus: [],
      onSubmiting: false,
      searchAccountant: '',
      filteredAccountantOptions: [],
      accountantOptions: [],
      selectedAccountantId: null,
      selectedAccountantCode: '',
      optionFailReasons: [],
      idempotenceKey: null,
      jobTitleId: null,
    };
  },
  components: {
    Treeselect,
    Autosuggest,
  },
  computed: {
    handleSearchCash() {
      return this.filteredAccountantOptions.length > 0
        ? this.searchAccountant
        : 'Không có thông tin loại tài khoản tiền mặt';
    },
    isEnabledCheckStatusApproval() {
      return this.isFeatureActive('check-status-approval-accountant'); //method from feature flag mixin
    },
  },
  created() {
    this.jobTitleId = JSON.parse(getData('employee_info'))?.jobTitleId;
  },
  methods: {
    checkPermission,
    initOptions() {
      const acceptStatusChanges = [
        APPROVAL_STEP_STATUS.PAID,
        APPROVAL_STEP_STATUS.PAY_FAILED,
        APPROVAL_STEP_STATUS.COMPLETED,
        APPROVAL_STEP_STATUS.CHECKED,
      ];
      const options = APPROVAL_STATUS.filter((approveStatus) =>
        acceptStatusChanges.includes(approveStatus.id),
      );
      this.optionStatus = options.reduce((result, element) => {
        result.push({
          id: element.id ? Number(element.id) : null,
          label: element.name,
          customLabel: element.name,
        });
        return result;
      }, []);
      const someApprovalTransfer = this.approvalItems.some(
        (approvalItem) =>
          approvalItem.paymentType === APPROVAL_PAYMENT_TYPE.TRANSFER,
      );
      if (someApprovalTransfer) {
        const waitForPaymentOption = APPROVAL_STATUS.find(
          ({ id }) => id === APPROVAL_STEP_STATUS.TRANSFER_ORDER_INITIALTED,
        );
        this.optionStatus.unshift({
          id: waitForPaymentOption?.id,
          label: waitForPaymentOption?.name,
          customLabel: waitForPaymentOption?.name,
        });
      }
      if (this.isEnabledCheckStatusApproval) {
        this.handleInitOptionApprovalStatus(someApprovalTransfer);
      } else {
        if (!JOB_TITLE_ACCOUNTANT.includes(this.jobTitleId)) {
          const accountantStatusOnly = APPROVAL_STATUS_ACCOUNTANT_ONLY.map(
            ({ id }) => id,
          );
          this.optionStatus = this.optionStatus.filter(({ id }) => {
            //TH thanh toán tiền chuyển khoản loại bỏ status đã thanh toán
            if (someApprovalTransfer) {
              return (
                id !== APPROVAL_STEP_STATUS.PAID &&
                !accountantStatusOnly.includes(id)
              );
            }
            return !accountantStatusOnly.includes(id);
          });
        }
      }

      // Khóa quyền cửa hàng với phiếu hoàn tiền chuyển khoản:
      // "Đã duyệt" chỉ cho chọn "Đã lập lệnh"; từ "Đã lập lệnh" trở đi để trống.
      // Phiếu tiền mặt và tài khoản kế toán giữ nguyên các option ở trên.
      const transferLockItem = this.approvalItems[0];
      const isAccountant = JOB_TITLE_ACCOUNTANT.includes(this.jobTitleId);
      if (
        transferLockItem &&
        transferLockItem.paymentType === APPROVAL_PAYMENT_TYPE.TRANSFER &&
        !isAccountant
      ) {
        if (transferLockItem.status === APPROVAL_STEP_STATUS.APPROVED) {
          // Dựng trực tiếp từ APPROVAL_STATUS vì id "Đã lập lệnh" có thể đã bị
          // các nhánh lọc phía trên loại khỏi optionStatus (non-QL/TL, hoặc flag off).
          const waitForPaymentOption = APPROVAL_STATUS.find(
            ({ id }) => id === APPROVAL_STEP_STATUS.TRANSFER_ORDER_INITIALTED,
          );
          this.optionStatus = [
            {
              id: waitForPaymentOption?.id,
              label: waitForPaymentOption?.name,
              customLabel: waitForPaymentOption?.name,
            },
          ];
        } else {
          this.optionStatus = [];
        }
      }

      this.optionFailReasons = FAIL_REASON.reduce((result, element) => {
        result.push({
          id: element.id ? Number(element.id) : null,
          label: element.name,
          customLabel: element.name,
        });
        return result;
      }, []);
    },
    handleInitOptionApprovalStatus(someApprovalTransfer) {
      const isStoreManager = JOB_TITLE_SHOW_BY_OWNER.includes(this.jobTitleId);
      if (!JOB_TITLE_ACCOUNTANT.includes(this.jobTitleId)) {
        const accountantStatusOnly = APPROVAL_STATUS_ACCOUNTANT_ONLY.map(
          ({ id }) => id,
        );
        this.optionStatus = this.optionStatus.filter(({ id }) => {
          //TH thanh toán tiền chuyển khoản loại bỏ status đã thanh toán
          if (someApprovalTransfer && id === APPROVAL_STEP_STATUS.PAID) {
            return false;
          }
          //Trạng thái chỉ dành cho kế toán
          const isAccountantOnlyStatus = accountantStatusOnly.includes(id);
          const isStoreManagerAllowed =
            isStoreManager &&
            id === APPROVAL_STEP_STATUS.TRANSFER_ORDER_INITIALTED;
          // Mở thêm quyền 'Đã lập lệnh' cho QL, TL cửa hàng
          return !isAccountantOnlyStatus || isStoreManagerAllowed;
        });
      }
    },
    htmlGetStatusValidate(item, type) {
      let name = '';
      switch (item.statusValidate) {
        case STATUS_VALIDATE.VALID: {
          name =
            type === 'class' ? 'fas fa-check-circle text-success' : 'Hợp lệ';

          break;
        }
        case STATUS_VALIDATE.REQUIRED: {
          name =
            type === 'class'
              ? 'fas fa-check-circle text-warning'
              : 'Chưa chọn lí do';
          break;
        }
        default: {
          name =
            type === 'class'
              ? 'fas fa-times-circle text-danger'
              : 'Không hợp lệ';
          break;
        }
      }
      return name;
    },
    onSelectStatus(node) {
      const statusChanged = node.id;
      this.approvalItems.map((item) => {
        const validateResult = this.validateChangeStatus(
          item.status,
          statusChanged,
          item.paymentType,
        );
        item.statusValidate = validateResult.statusValidate;
        item.statusValidateName = validateResult.statusValidateName;
        if (statusChanged === APPROVAL_STEP_STATUS.PAID) {
          this.fetchAccountants(item.paymentType, item.storeId);
        }
      });
    },
    showModal: function (data) {
      this.$refs['approval-change-status'].show();
      this.approvalItems = [cloneDeep(data)];
      this.selectedAccountantId = null;
      this.selectedAccountantCode = '';
      this.searchAccountant = '';
      this.initOptions();
    },
    hideModal() {
      this.$refs['approval-change-status'].hide();
    },
    validateChangeStatus(currentStatus, selectedStatus, paymentType) {
      if (currentStatus === selectedStatus) {
        return {
          statusValidate: STATUS_VALIDATE.INVALID,
          statusValidateName: 'Trùng trạng thái',
        };
      }
      const isAccountant = JOB_TITLE_ACCOUNTANT.includes(this.jobTitleId);
      if (paymentType === APPROVAL_PAYMENT_TYPE.TRANSFER && !isAccountant) {
        // Cửa hàng + chuyển khoản: chỉ hợp lệ khi "Đã duyệt" -> "Đã lập lệnh".
        const isAllowedTransition =
          currentStatus === APPROVAL_STEP_STATUS.APPROVED &&
          selectedStatus === APPROVAL_STEP_STATUS.TRANSFER_ORDER_INITIALTED;
        if (!isAllowedTransition) {
          if (currentStatus === APPROVAL_STEP_STATUS.APPROVED) {
            return {
              statusValidate: STATUS_VALIDATE.INVALID,
              statusValidateName:
                'Cửa hàng chỉ được cập nhật trạng thái Đã lập lệnh cho phiếu chuyển khoản!',
            };
          }
          return {
            statusValidate: STATUS_VALIDATE.INVALID,
            statusValidateName:
              'Phiếu chuyển khoản đã lập lệnh chỉ kế toán mới được xử lý tiếp!',
          };
        }
      }
      if (currentStatus === APPROVAL_STEP_STATUS.CHECKED) {
        return {
          statusValidate: STATUS_VALIDATE.INVALID,
          statusValidateName:
            'Không thể đổi trạng thái phiếu đã hoàn thành hậu kiểm!',
        };
      }
      if (
        selectedStatus === APPROVAL_STEP_STATUS.CHECKED &&
        currentStatus !== APPROVAL_STEP_STATUS.COMPLETED
      ) {
        return {
          statusValidate: STATUS_VALIDATE.INVALID,
          statusValidateName:
            'Chỉ có thể đổi trạng thái đã hậu kiểm cho phiếu đã hoàn thành!',
        };
      }
      if (
        currentStatus === APPROVAL_STEP_STATUS.COMPLETED &&
        selectedStatus !== APPROVAL_STEP_STATUS.CHECKED
      ) {
        return {
          statusValidate: STATUS_VALIDATE.INVALID,
          statusValidateName:
            'Phiếu trạng thái hoàn thành chỉ được cập nhật thành Đã hậu kiểm!',
        };
      }
      if (currentStatus === APPROVAL_STEP_STATUS.CANCELED) {
        return {
          statusValidate: STATUS_VALIDATE.INVALID,
          statusValidateName: 'Không thể đổi trạng thái phiếu đã bị hủy!',
        };
      }
      if (currentStatus === APPROVAL_STEP_STATUS.PAY_FAILED) {
        return {
          statusValidate: STATUS_VALIDATE.INVALID,
          statusValidateName:
            'Không thể đổi trạng thái phiếu thanh toán thất bại!',
        };
      }
      if (
        currentStatus === APPROVAL_STEP_STATUS.PAID &&
        selectedStatus !== APPROVAL_STEP_STATUS.COMPLETED
      ) {
        return {
          statusValidate: STATUS_VALIDATE.INVALID,
          statusValidateName:
            'Chỉ có thể cập nhật Đã hoàn thành cho phiếu Đã thanh toán!',
        };
      }
      if (
        paymentType === APPROVAL_PAYMENT_TYPE.TRANSFER &&
        (selectedStatus === APPROVAL_STEP_STATUS.PAID ||
          selectedStatus === APPROVAL_STEP_STATUS.PAY_FAILED)
      ) {
        if (!this.checkPermission('APPROVAL_PAID')) {
          return {
            statusValidate: STATUS_VALIDATE.INVALID,
            statusValidateName:
              'Bạn không có quyền cập nhật trạng thái thanh toán cho phiếu duyệt chi này!',
          };
        }
      }
      if (
        currentStatus === APPROVAL_STEP_STATUS.APPROVED &&
        selectedStatus === APPROVAL_STEP_STATUS.COMPLETED
      ) {
        return {
          statusValidate: STATUS_VALIDATE.INVALID,
          statusValidateName: 'Vui lòng cập nhật trạng thái thanh toán trước!',
        };
      }
      return {
        statusValidate: STATUS_VALIDATE.VALID,
        statusValidateName: 'Hợp lệ!',
      };
    },
    async onSubmit() {
      if (this.onSubmiting) {
        return;
      }

      for (const approvalItem of this.approvalItems) {
        if (!approvalItem.toStatus) {
          approvalItem.statusValidate = STATUS_VALIDATE.REQUIRED;
          approvalItem.statusValidateName = 'Vui lòng chọn trạng thái cần đổi!';
          makeToastFaile('Vui lòng chọn trạng thái cần đổi!');
          return;
        }
      }
      if (!this.isValidDataSubmit()) {
        return makeToastFaile('Vui lòng chọn trạng thái hợp lệ!');
      }
      for (const approvalItem of this.approvalItems) {
        await this.onCallUpdateStatus(approvalItem);
      }
      this.$emit('submit-data-success', true);
      this.hideModal();
      this.onSubmiting = false;
    },
    async onCallUpdateStatus(data) {
      if (!this.idempotenceKey) {
        this.idempotenceKey = uuidv4();
      }

      const payload = {
        id: data.id,
        status: data.toStatus,
        accountantId: this.selectedAccountantId,
        accountantName: this.searchAccountant,
        accountantCode: this.selectedAccountantCode,
        failReason: data.failReason,
      };
      this.onSubmiting = true;
      await ApiService.put('v2/approvals/status', payload, this.idempotenceKey)
        .then(({ data }) => {
          this.idempotenceKey = uuidv4();
          makeToastSuccess(data.message);
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile(err.$error);
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
        });
    },
    isValidDataSubmit() {
      const inValidItem = this.approvalItems.find(
        (item) => item.statusValidate !== STATUS_VALIDATE.VALID,
      );
      return inValidItem ? false : true;
    },
    onSelectedAccountant(option) {
      this.searchAccountant = option.item.name;
      this.selectedAccountantId = option.item.id;
      this.selectedAccountantCode = option.item.code;
    },
    onInputChangeAccountant(text) {
      this.searchAccountant = text;
      const filteredData = this.accountantOptions
        .filter((item) => {
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.code.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, this.limit);
      this.filteredAccountantOptions = [...filteredData];
    },
    fetchAccountants: async function (paymentType, storeId) {
      this.accountantOptions = [];
      let params = {
        type: paymentType,
      };
      let url = cmdUrl.AccountantUrl.byType;
      if (paymentType === 1) {
        url = 'accountants/getByStore';
        params = {
          type: paymentType,
          storeId: storeId,
        };
      }
      await ApiService.query(url, {
        params,
      }).then((response) => {
        const data = response.data.data || [];
        map(data, (item) => {
          const element = {
            id: item.id,
            code: item.code,
            name: item.name,
            suggestionName: `(${item.code}) - ${item.name}`,
          };
          this.accountantOptions.push(element);
        });
        this.filteredAccountantOptions = [...this.accountantOptions];
      });
    },
    isShowOption(item, name) {
      if (item.statusValidate === STATUS_VALIDATE.INVALID) {
        return false;
      }
      if (name === 'accountant') {
        return item.toStatus === APPROVAL_STEP_STATUS.PAID;
      }
      if (name === 'fail-reason') {
        return item.toStatus === APPROVAL_STEP_STATUS.PAY_FAILED;
      }
    },
  },
};
</script>

<style scoped>
.table-common /deep/ .vue-treeselect__input-container {
  padding-top: 0px;
}
.table-common /deep/ .vue-treeselect__control {
  border-radius: none;
  border: none;
  height: 2.5rem;
}

.table-common /deep/ .vue-treeselect__input {
  font-size: 22px;
}
</style>
